import { isEqual } from "lodash"
import { useRef } from "react"

export const useDeepCompareMemoise = <T>(value: T): T => {
  const ref = useRef<T>(value)

  if (!isEqual(value, ref.current)) {
    ref.current = value
  }

  return ref.current
}
